import { useContext } from 'react'
import { AppState } from 'App'

import SampleUser from 'assets/user.png'

const Avatar = ({width, height}) => {

    const [appState] = useContext(AppState)

    return (
        <div>
            {appState.userPhoto ?
            <img src={appState.userPhoto} className={'rounded-full w-'+width+' h-'+height}  alt={appState.username+"'s Avatar"}/>
            :
            <img src={SampleUser} className={'rounded-full w-'+width+' h-'+height}  alt="a generic avatar"/>
            }
        </div>
    )
}

export default Avatar
